<footer class="it-footer">
	<div class="it-footer-main">
		<div class="container">
			<section>
				<div class="row clearfix">
					<div class="col-sm-12">
						<div class="it-brand-wrapper">
							<div class="richtext-blocks footerTop">
								<div class="block gridBlock three">
									<div class="row">
										<div class="col-lg-8 col-md-8 col-sm-12 pb-2">
											<p class="block image align center desktop-mobile">
												<img
													class="footer-logo-rer"
													[src]="
														'https://' +
														resourceUrl +
														'/includes/TemplatesER/-cdn/marchio-rer-w.png'
													"
													alt=""
													loading="lazy" />
											</p>
											<h5>Direzione generale Cura del territorio e dell'ambiente</h5>
											<p>Viale Aldo Moro 30 - <strong></strong>40127 Bologna</p>
										</div>
										<div class="col-lg-4 col-md-4 col-sm-12 pb-2">
											<h4 class="border-white border-bottom">
												<a>Redazione</a>
											</h4>
											<div class="link-list-wrapper">
												<ul class="footer-list link-list clearfix">
													<li>
														<a
															class="list-item"
															href="https://mobilita.regione.emilia-romagna.it/info"
															>Informazioni sul sito e crediti</a
														>
													</li>
													<li class="d-flex align-items-center gap-1">
														<strong>Scrivici</strong>
														<a
															class="list-item"
															href="https://mobilita.regione.emilia-romagna.it/scrivici"
															title="Si apre in una nuova scheda"
															rel="noopener noreferrer"
															>e-mail
														</a>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section class="border-white border-bottom">
				<div class="row">
					<div class="col-lg-4 col-md-4 col-sm-6 pb-2">
						<h4 class="border-white border-bottom">
							<a>Recapiti</a>
						</h4>
						<p>
							<strong>Regione Emilia-Romagna</strong><br />Viale Aldo Moro, 52<strong><br /></strong>40127
							Bologna
						</p>
						<div class="link-list-wrapper">
							<ul class="footer-list link-list clearfix">
								<li class="d-flex align-items-center gap-1">
									<strong>Centralino</strong>
									<a
										class="list-item"
										href="tel:+39.0515271"
										title="Si apre in una nuova scheda"
										rel="noopener noreferrer"
										>051 5271
										<app-icon name="it-external-link" color="white" innerClass="icon icon-xs">
										</app-icon>
									</a>
								</li>
								<li>
									<a
										class="list-item"
										[href]="'http://' + resourceUrl + '/Cercaregione/Default.aspx?cons=0'"
										title="Si apre in una nuova scheda"
										target="_blank"
										rel="noopener noreferrer"
										>Cerca telefoni o indirizzi<app-icon
											name="it-external-link"
											color="white"
											innerClass="icon icon-xs"></app-icon>
									</a>
								</li>
							</ul>
						</div>
					</div>
					<div class="col-lg-4 col-md-4 col-sm-6 pb-2">
						<h4 class="border-white border-bottom">
							<a>URP</a>
						</h4>
						<div class="link-list-wrapper">
							<ul class="footer-list link-list clearfix">
								<li class="d-flex gap-1">
									<strong style="white-space: nowrap">Sito web</strong>
									<a class="list-item" href="www.regione.emilia-romagna.it/urp/"
										>www.regione.emilia-romagna.it/urp/</a
									>
								</li>
								<!-- <li class="d-flex align-items-center gap-1">
									<strong>Numero verde</strong>
									<a
										class="list-item"
										href="tel:+39.800662200 "
										title="Si apre in una nuova scheda"
										rel="noopener noreferrer"
										>800.66.22.00
										<app-icon name="it-external-link" color="white" innerClass="icon icon-xs">
										</app-icon>
									</a>
								</li> -->
								<li class="d-flex align-items-center gap-1">
									<!-- <strong>Scrivici</strong>
									<a
										class="list-item"
										href="mailto:urp@regione.emilia-romagna.it"
										title="Si apre in una nuova scheda"
										rel="noopener noreferrer"
										>e-mail
										<app-icon name="it-external-link" color="white" innerClass="icon icon-xs">
										</app-icon>
									</a>
									- -->
									<a
										class="list-item"
										href="mailto:urp@postacert.regione.emilia-romagna.it"
										title="Si apre in una nuova scheda"
										rel="noopener noreferrer"
										>PEC
										<app-icon name="it-external-link" color="white" innerClass="icon icon-xs">
										</app-icon>
									</a>
								</li>
							</ul>
						</div>
					</div>
					<div class="col-lg-4 col-md-4 col-sm-6 pb-2">
						<h4 class="border-white border-bottom">
							<a>Trasparenza</a>
						</h4>
						<div class="link-list-wrapper">
							<ul class="footer-list link-list clearfix">
								<li class="d-flex align-items-center gap-1">
									<a
										class="list-item"
										href="http://trasparenza.regione.emilia-romagna.it/"
										title="Si apre in una nuova scheda"
										target="_blank"
										rel="noopener noreferrer"
										class=""
										>Amministrazione trasparente<app-icon
											name="it-external-link"
											color="white"
											innerClass="icon icon-xs">
										</app-icon
									></a>
								</li>
								<!-- <li class="d-flex align-items-center gap-1">
									<a
										class="list-item"
										href="https://trasparenza.regione.emilia-romagna.it/altri-contenuti/anticorruzione/segnala-irregolarita-o-illeciti"
										title="Si apre in una nuova scheda"
										target="_blank"
										rel="noopener noreferrer"
										class=""
										>Segnala illeciti<app-icon
											name="it-external-link"
											color="white"
											innerClass="icon icon-xs">
										</app-icon
									></a>
								</li> -->
								<!-- <li>
									<a class="list-item" href="/amministrazione/avvisi">Atti di notifica</a>
								</li> -->
								<li>
									<a class="list-item" href="http://www.regione.emilia-romagna.it/note-legali"
										>Note legali e copyright</a
									>
								</li>
								<li>
									<a class="list-item" href="https://mobilita.regione.emilia-romagna.it/privacy"
										>Privacy e cookie</a
									>
								</li>
								<!-- <li>
									<a class="list-item" href="https://mobilita.regione.emilia-romagna.it/@@search#"
										>Gestisci i cookie</a
									>
								</li> -->
								<li>
									<a class="list-item" href="https://mobilita.regione.emilia-romagna.it/accessibilita"
										>Dichiarazione di accessibilità
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
	<div class="it-footer-small-prints clearfix">
		<div class="container">
			<ul class="it-footer-small-prints-list list-inline mb-0 d-flex flex-column flex-md-row">
				<li class="list-inline-item"><a class="list-item">C.F. 800.625.903.79</a></li>
			</ul>
		</div>
	</div>
</footer>
